export default {
  name: "Tag",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M14.25 29.96c-.51 0-1.02-.19-1.41-.58L2.63 19.16a2.01 2.01 0 0 1 0-2.83L16.38 2.59c.38-.38.88-.59 1.41-.59H28a2 2 0 0 1 2 2v10.21a2 2 0 0 1-.58 1.41L15.66 29.37a2 2 0 0 1-1.41.59zM17.79 4 4.04 17.75l10.21 10.2L28 14.21V4H17.79zm2.71 11a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7zm0-5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z",
  },
}
